export default __webpack_public_path__ + "static/jeep1-5c257c5c6a961f7bf01b6452885fb1e8.jpg";